import { Enum, EnumBaseInstance } from 'model-core';

class ReportingHistoryStatusEnum extends Enum {}
class ReportingHistoryStatusEnumInstance extends EnumBaseInstance {}

/**
 * Reporting History status
 */

export default new ReportingHistoryStatusEnum(
  {
    enrolled: {
      displayName: 'Enrolled',
    },
    reported: {
      displayName: null,
    },
    pending: {
      displayName: 'Upcoming',
    },
    processing: {
      displayName: 'Processing...',
    },
    unenrolled: {
      displayName: 'Canceled',
    },
    delayed: {
      displayName: 'Delayed',
    },
  },
  ReportingHistoryStatusEnumInstance
);
